import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';

class DialogWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: this.props.title,
            message: this.props.message,
            messageButton: this.props.messageButton,
        };
    }

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        handleCloseDialog: PropTypes.func.isRequired,
        title: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
        messageButton: PropTypes.string,
        buttonStyles: PropTypes.object,
    };

    static defaultProps = {
        messageButton: 'OK',
        buttonStyles: {
            backgroundColor: 'rgb(255, 186, 0)',
            color: '#FFFFFF',
        },
    };

    closeDialog = () => {
        this.props.handleCloseDialog();
    };

    render() {
        const { title, message, messageButton } = this.state;
        const actionsSuccess = [
            <RaisedButton
                label={messageButton}
                buttonStyle={this.props.buttonStyles}
                labelColor={this.props.buttonStyles.color}
                onClick={this.closeDialog}
            />,
        ];

        return (
            <MuiThemeProvider>
                <Dialog
                    title={title}
                    actions={actionsSuccess}
                    modal
                    open={this.props.isOpen}
                >
                    {message}
                </Dialog>
            </MuiThemeProvider>
        );
    }
}

export default DialogWrapper;
